<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="90" label-position="right" inline>
          <Row :gutter="16">
            <Col span="4">
            <FormItem label="客户名:" :label-width="70" style="width: 100%">
              <Input v-model="params.Name" placeholder=""></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="省份：" :label-width="70" style="width: 100%">
              <Select v-model="params.Province" placeholder="">
                <Option value="">---</Option>
                <Option v-for="(item, index) in provinceData" :value="item.value" :key="index">
                  {{ item.name }}
                </Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="城市:" :label-width="70" style="width: 100%">
              <Input v-model="params.City" placeholder=""></Input>
              <!-- <Cascader :data="cities" v-model="params.city"></Cascader> -->
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="地址:" :label-width="70" style="width: 100%">
              <Input v-model="params.Address" placeholder=""></Input>
            </FormItem>
            </Col>
			<Col span="4">
				<FormItem label="业务员：" style="width: 100%">
				  <Select v-model="params.Salesman" placeholder="">
					<Option value="">---</Option>
					<Option v-for="(item, index) in userData" :value="item.value" :key="index">
					  {{ item.name }}
					</Option>
				  </Select>
				</FormItem>
			</Col>
			</Row>
			<Row :gutter="16">
           
			<Col span="4">
				<FormItem label="状态：" style="width: 100%">
				  <Select v-model="params.Status" placeholder="">
					<Option value="">---</Option>
					<Option v-for="(item, index) in statusData" :value="item.value" :key="index">
					  {{ item.name }}
					</Option>
				  </Select>
				</FormItem>
			</Col>
            <Button icon="ios-search" type="primary" size="default" @click="queryTab" class="toolbar-btn">{{ '查询' }}</Button>
            <Button @click="addSupper" icon="md-add" type="primary" size="default" class="toolbar-btn">{{ '添加正式客户' }}</Button>
            <Button @click="addSupper2" icon="md-add" type="primary" size="default" class="toolbar-btn">{{ '添加潜在客户' }}</Button>
          </Row>
        </Form>
        <div v-if="list">
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="params.MaxResultCount" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
	<div v-if="createShow">
    <NewCustomer :value="createShow" :isAdd="isAdd" @close="close" :departmentType="$constDefinition.ODM事业部" :id="itemId" @getTab="getTab" :userData="userData" :provinceData="provinceData" :enterpriseNatureData="enterpriseNatureData"  :iszskh="true" :customerType="customerType" />
    </div>
	<div v-if="createShow2">
    <NewCustomer :value="createShow2" :isAdd="isAdd" @close="close" :departmentType="$constDefinition.ODM事业部" :id="itemId" @getTab="getTab" :userData="userData" :provinceData="provinceData" :enterpriseNatureData="enterpriseNatureData" :iszskh="false" :customerType="customerType" />
    </div>
	<div v-if="quotationModelShow">
      <Quotation :show='quotationModelShow' :customerId="itemId" @close="closeModel" :isDetail="isDetail"></Quotation>
    </div>
    <div v-if="contractModelShow">
      <Contract :show='contractModelShow' :customerId="itemId" @close="closeModel" :isDetail="isDetail"></Contract>
    </div>
    <div v-if="settlementModelShow">
      <Settlement :show='settlementModelShow' :customerId="itemId" @close="closeModel" :isDetail="isDetail"></Settlement>
    </div>
    <div v-if="afterSalesModelShow">
      <AfterSales :show='afterSalesModelShow' :customerId="itemId" @close="closeModel" :isDetail="isDetail"></AfterSales>
    </div>
	<!-- 详情 -->
	<div v-if='detailShow'>
	  <Detail :show='detailShow' @close="closeModel" :id="itemId" @getTab="getTab"></Detail>
	</div>
    <!-- <div v-if="bidModelShow">
      <Bid :show='bidModelShow' :customerId="itemId" @close="closeModel"></Bid>
    </div> -->
	<Modal v-model="optionModel" title="原因" :styles="{top:'140px'}"  @on-ok="examineNoPass(leaveId)" @on-cancel="onClose" width="480">
	  <Form ref="examineModel" :label-width="20" :rules="ruleValidate" :model="examineModel">
	    <FormItem prop="examineText">
	      <Input v-model="examineModel.examineText" type="textarea" placeholder="请输入">
	      </Input>
	    </FormItem>
	  </Form>
	  <div slot="footer">
	    <Button @click="onClose">取消</Button>
	    <Button type="primary" @click="examineNoPass(leaveId)">确定</Button>
	  </div>
	</Modal>
	<Modal v-model="optionChangeModel" title="补充金蝶内客户编码" :styles="{top:'140px'}"  @on-ok="changeCustomerType()" @on-cancel="onClose" width="480">
	  <Form ref="changeCustomerTypeModel" :label-width="20" :rules="ruleValidate" :model="changeCustomerTypeModel">
	    <FormItem prop="zipCode">
	      <Input v-model="changeCustomerTypeModel.zipCode" type="textarea" placeholder="请输入金蝶内客户编码">
	      </Input>
	    </FormItem>
	  </Form>
	  <div slot="footer">
	    <Button @click="onClose">取消</Button>
	    <Button type="primary" @click="changeCustomerType()">确定</Button>
	  </div>
	</Modal>
  </div>
</template>

<script>
import NewCustomer from './newcustomer.vue'
import Quotation from './modules/quotation.vue'
import Contract from './modules/contract.vue'
import Settlement from './modules/settlement.vue'
import AfterSales from './modules/afterSales.vue'
import Detail from './modules/detail.vue'
// import Bid from './modules/bid.vue'
import { city } from '../../lib/city'
import { getCustomersAndContact, removeCustomer, changeCustomerType, getYWY,submitCustomerBusinessLicenseExamine,submitCustomerOrganizationChartExamine,submitCustomerExamine,submitCustomerDirectorExamine,customerExamine,customerExamineNoPass } from '../../api/index'
import expandTable from './table-expand.vue'
import { number } from 'echarts'
export default {
  name: 'customerInfoODM',
  data() {
    return {
      list: [],
      itemId: 0,
      params: {
        Name: '',
        City: '',
        Address: '',
        Province: null,
		Salesman:null,
		query_客户管理ODM:true,
        IncludeCreatoUser: true,
        SkipCount: 0,
        MaxResultCount: 10,
      },
      totalCount: 0,
      currentPage: 1,
      loading: false,
      createShow: false,
      createShow2: false,
      quotationModelShow: false,
      contractModelShow: false,
      settlementModelShow: false,
      afterSalesModelShow: false,
	  detailShow:false,
	  customerType:null,
      // bidModelShow: false,
      isAdd: '',
      columns: [],
	  examineModel:{
		  id:0,
		  examineText:""
	  },
	  changeCustomerTypeModel:{
	  		  id:0,
	  		  zipCode:""
	  },
	  optionModel:false,
	  optionChangeModel:false,
	  isDetail:false,
      cities: city,
      userData: [],
      statusData: [],
      provinceData: [],
	  ruleValidate: {
	    examineText: [{ required: true, message: '请输入不通过原因', trigger: 'change' }],
		zipCode: [{ required: true, message: '不能为空', trigger: 'blur' }],
	  },
      enterpriseNatureData: [],
    }
  },
  components: {
    NewCustomer,
    expandTable,
    Quotation,
    Contract,
    Settlement,
    AfterSales,
	Detail
    // Bid,
  },
  mounted() {
    this.getTab()
    this.getColumns()
  },
  created() {
    this.getInit()
  },
  methods: {
	  
    //获取表格数据
    async getTab(row) {
      const data = await getCustomersAndContact(this.params)
      let arr = []
      if (row) {
        data.data.result.items.forEach((item) => {
          if (item.id == row) {
            item._expanded = true
          }
          arr.push(item)
        })

        this.list = [...arr]
        console.log(this.list)
        this.totalCount = data.data.result.totalCount
      } else {
        this.list = data.data.result.items
        this.totalCount = data.data.result.totalCount
      }
	  console.log("123123");
    },
    async getInit() {
		const res = await getYWY(this.params)
      this.userData = res.data.result.userData
      this.provinceData = res.data.result.provinceData
      this.enterpriseNatureData = res.data.result.enterpriseNatureData
	  this.statusData=res.data.result.statusData
	  console.log("123123");
    },
    //查询
    queryTab() {
      this.params.SkipCount = 0
      this.currentPage = 1
      this.$nextTick(() => {})
      this.getTab()
    },
    addSupper() {
      this.isAdd = '添加正式客户'
	  this.customerType=this.$constDefinition.正式客户
      this.createShow = true
    },
    addSupper2() {
      this.isAdd = '添加潜在客户'
	  this.customerType=this.$constDefinition.潜在客户
      this.createShow2 = true
    },
    //分页
    pageChange(size) {
      this.params.SkipCount = (size - 1) * this.params.MaxResultCount
      this.getTab()
    },
    pagesizeChange(size) {
      this.params.MaxResultCount = size
      this.getTab()
    },
    //关闭弹框
    close() {
      this.createShow = false
      this.createShow2 = false
	  this.customerType=null
    },
    //表格
    getColumns() {
      let _this = this
      this.columns = [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h(expandTable, {
              props: {
                row: params.row.customerContactsList,
              },
              on: {
                async getTab(data) {
                  if (data) {
                    _this.getTab(data)
                  } else {
                    _this.getTab()
                  }
                },
              },
            })
          },
        },
        {
          title: '客户全名',
          width:180,
          key: 'c客户名',
        },
        {
          title: '客户简名',
          width:135,
          key: 'simpleName',
        },
        {
          title: '客户类型',
          width:110,
          key: 'customerTypeText',
        },
        {
          title: '事业部',
          width:135,
          key: 'departmentTypeText',
        },
        
        {
          title: '省份',
          width:90,
          key: 'provinceText',
        },
        {
          title: '税号',
          width:130,
          key: 'dutyParagraph',
        },
        {
          title: '业务员',
          width:130,
          key: 'c业务员',
          render: (h, params) => {
            return h('span', params.row.业务员Info.name)
          },
        },
        {
          title: '状态',
          width:120,
          key: 'statusText',
        },
        {
          title: '营业执照状态',
          width:140,
          key: 'businessLicenseStatusText',
        },
        {
          title: '组织架构图状态',
          width:140,
          key: 'organizationChartStatusText',
        },
        {
          title: '创建时间',
          width:180,
		  key: 'creationTimeText',
        },
        {
          title: '操作',
          align: 'left',
		  fixed: 'right',
          width: 350,
          render: (h, params) => {
            return h(
              'div',
              {
                style: {
                  marginTop: '5px',
                },
              },
              [
				h(
				    'Button',
				    {
				      props: {
				        type: 'primary',
				        size: 'small',
				      },
				      style: {
				        margin: '5px',
				        marginLeft: '0px',
				        marginTop: '0px',
				  	  display: params.row.isShow编辑 ? 'inline-block' : 'none',
				      },
				      on: {
				        click: () => {
				          _this.itemId = params.row.guid
				          _this.isAdd = '编辑客户'
						  _this.customerType=params.row.customerType
				          if(params.row.customerType==this.$constDefinition.正式客户)
							_this.createShow = true
				          if(params.row.customerType==this.$constDefinition.潜在客户)
							_this.createShow2 = true
				        },
				      },
				    },
				    '编辑'
				  ),
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display: params.row.isShow详情 ? 'inline-block' : 'none',
				    },
				    on: {
				      click: () => {
				        _this.itemId = params.row.guid
				        _this.isAdd = '详情'
						_this.customerType=params.row.customerType
				        if(params.row.customerType==this.$constDefinition.正式客户)
							_this.createShow = true
				        if(params.row.customerType==this.$constDefinition.潜在客户)
							_this.createShow2 = true
				      },
				    },
				  },
				  '基本信息'
				),
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display: params.row.isShow补全信息 ? 'inline-block' : 'none',
				    },
				    on: {
				      click: () => {
				        this.itemId = params.row.guid
				        this.detailShow = true
				      },
				    },
				  },
				  '详情'
				),
				h(
				  'Button',
				  {
				    props: {
				      type: 'warning',
				      size: 'small',
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display: params.row.isShow提交营业执照审核 ? 'inline-block' : 'none',
				    },
				    on: {
				      click: async () => {
				        this.$Modal.confirm({
				          title: '确定提交营业执照审核？',
				          okText: '确认',
				          cancelText: '取消',
				          onOk: async () => {
				            let res = await submitCustomerBusinessLicenseExamine(params.row.id)
				            if (res.data.success) {
				              this.$Message.success('提交成功')
				            } else {
				              this.$Message.success('提交失败')
				            }
				            this.getTab()
				          },
				        })
				      },
				    },
				  },
				  '提交营业执照审核'
				),
				h(
				  'Button',
				  {
				    props: {
				      type: 'warning',
				      size: 'small',
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display:
					    params.row.isShow提交组织架构图审核
					      ? 'inline-block'
					      : 'none',
				    },
				    on: {
				      click: async () => {
				        this.$Modal.confirm({
				          title: '确定提交组织架构图审核？',
				          okText: '确认',
				          cancelText: '取消',
				          onOk: async () => {
				            let res = await submitCustomerOrganizationChartExamine(params.row.id)
				            if (res.data.success) {
				              this.$Message.success('提交成功')
				            } else {
				              this.$Message.success('提交失败')
				            }
				            this.getTab()
				          },
				        })
				      },
				    },
				  },
				  '提交组织架构图审核'
				),
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small',
					  
                    },
                    style: {
                      margin: '5px',
                      marginLeft: '0px',
                      marginTop: '0px',
					  display:
					    params.row.isShow补全信息
					      ? 'inline-block'
					      : 'none',
                    },
                    on: {
                      click: () => {
                        _this.itemId = params.row.id
                        _this.isAdd = '添加联系人'
                        _this.createShow = true
                      },
                    },
                  },
                  '新增联系人'
                ),
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
					  
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display:
					    params.row.isShow补全信息
					      ? 'inline-block'
					      : 'none',
				    },
				    on: {
				      click: () => {
				        _this.itemId = params.row.id
						_this.isDetail=!params.row.isShow编辑
				        _this.contractModelShow = true
				      },
				    },
				  },
				  '合同信息'
				),
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
					  
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display:
					    params.row.isShow补全信息
					      ? 'inline-block'
					      : 'none',
				    },
				    on: {
				      click: () => {
				        _this.itemId = params.row.id
						_this.isDetail=!params.row.isShow编辑
				        _this.quotationModelShow = true
				      },
				    },
				  },
				  '报价信息'
				),
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
					  
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display:
					    params.row.isShow补全信息
					      ? 'inline-block'
					      : 'none',
				    },
				    on: {
				      click: () => {
				        _this.itemId = params.row.id
						_this.isDetail=!params.row.isShow编辑
				        _this.settlementModelShow = true
				      },
				    },
				  },
				  '结算信息'
				),
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
					  
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display:
					    params.row.isShow补全信息
					      ? 'inline-block'
					      : 'none',
				    },
				    on: {
				      click: () => {
				        _this.itemId = params.row.id
						_this.isDetail=!params.row.isShow编辑
				        _this.afterSalesModelShow = true
				      },
				    },
				  },
				  '售后信息'
				),
       //          h(
       //            'Button',
       //            {
       //              props: {
       //                type: 'primary',
       //                size: 'small',
       //              },
       //              style: {
       //                margin: '5px',
       //                marginLeft: '0px',
       //                marginTop: '0px',
					  // display:
					  //   params.row.isShow补全信息
					  //     ? 'inline-block'
					  //     : 'none',
       //              },
       //              on: {
       //                click: () => {
       //                  _this.itemId = params.row.id
       //                  _this.bidModelShow = true
       //                },
       //              },
       //            },
       //            '招投标信息'
       //          ),
				h(
				  'Button',
				  {
				    props: {
				      type: 'warning',
				      size: 'small',
					  disabled:params.row.customerType==this.$constDefinition.潜在客户
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display:
					    params.row.isShow提交审核
					      ? 'inline-block'
					      : 'none',
				    },
				    on: {
				      click: async () => {
				        this.$Modal.confirm({
				          title: '确定提交审核？',
				          okText: '确认',
				          cancelText: '取消',
				          onOk: async () => {
							let res = await submitCustomerExamine(params.row.id)
							if (res.data.result.success) {
							  this.$Message.success('提交成功')
							  this.getTab()
							} else {
								var timer=null
								clearTimeout(timer)
								timer= setTimeout(() => {
									this.$Modal.error({
						                title: '错误',
						                content: res.data.result.message,
					            	});
								}, 1000);
							}
				          },
				        })
				      },
				    },
				  },
				  '提交审核'
				),
				h(
				  'Button',
				  {
				    props: {
				      type: 'warning',
				      size: 'small',
					  disabled:params.row.customerType==this.$constDefinition.潜在客户
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display:
					    params.row.isShow提交执行董事审核
					      ? 'inline-block'
					      : 'none',
				    },
				    on: {
				      click: async () => {
				        this.$Modal.confirm({
				          title: '确定提交审核？',
				          okText: '确认',
				          cancelText: '取消',
				          onOk: async () => {
				            let res = await submitCustomerDirectorExamine(params.row.id)
				            if (res.data.success) {
				              this.$Message.success('提交成功')
				            } else {
				              this.$Message.success('提交失败')
				            }
				            this.getTab()
				          },
				        })
				      },
				    },
				  },
				  '提交审核'
				),
				h(
				  'Button',
				  {
				    props: {
				      type: 'warning',
				      size: 'small',
				    },
				    style: {
				      margin: '5px',
				      marginLeft: '0px',
				      marginTop: '0px',
					  display: params.row.isShow转换为正式客户 ? 'inline-block' : 'none',
				    },
				    on: {
				      click: async () => {
				        _this.changeCustomerTypeModel.id = params.row.id
				        _this.optionChangeModel = true
				      },
				    },
				  },
				  '转换为正式客户'
				),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small',
                    },
                    style: {
                      margin: '5px',
                      marginLeft: '0px',
                      marginTop: '0px',
					  display: params.row.isShow删除 ? 'inline-block' : 'none',
                    },
                    on: {
                      click: async () => {
                        this.$Modal.confirm({
                          title: '确定删除数据？',
                          content: '删除后不可撤销',
                          okText: '确认',
                          cancelText: '取消',
                          onOk: async () => {
                            let res = await removeCustomer(params.row.id)
                            if (res.data.success) {
                              this.$Message.success('删除成功')
                            } else {
                              this.$Message.success('删除失败')
                            }
                            this.getTab()
                          },
                        })
                      },
                    },
                  },
                  '删除'
                ),
              ]
            )
          },
        },
      ]
    },
    //关闭弹框
    closeModel() {
      this.quotationModelShow = false
      this.contractModelShow = false
      this.settlementModelShow = false
      this.afterSalesModelShow = false
	  this.detailShow=false
      // this.bidModelShow = false
      this.getTab()
    },
	//关闭抽屉
	onClose() {
	  this.optionModel = false
	  this.optionChangeModel=false
	  this.changeCustomerTypeModel={
		  id:0,
		  zipCode:""
	  }
	},
	examineNoPass(leaveId) {
	  this.$refs['examineModel'].validate(async (valid) => {
	    if (valid) {
			this.spinShow = true
	      let res = await customerExamineNoPass(this.examineModel)
	      if (res.data.success) {
			  this.onClose()
			  this.spinShow = false
			  this.getTab()
	        this.$Message.success({ content: '审核成功', duration: 5 })
	      } else {
			  this.onClose()
			  this.spinShow = false
			  this.getTab()
	        this.$Message.error({ content: '审核失败', duration: 5 })
	      }
		  }})
	},
	changeCustomerType() {
	  this.$refs['changeCustomerTypeModel'].validate(async (valid) => {
	    if (valid) {
			this.spinShow = true
	      let res = await changeCustomerType(this.changeCustomerTypeModel)
		  
	      if (res.data.success) {
			  this.onClose()
			  this.spinShow = false
			  this.getTab()
	        this.$Message.success({ content: '转换成功', duration: 5 })
	      } else {
			  this.onClose()
			  this.spinShow = false
			  this.getTab()
	        this.$Message.error({ content: '转换失败', duration: 5 })
	      }
		  }})
	},
  },
}
</script>

<style scoped lang="less">
.app {
  min-width: 1260px;
}

/deep/ .ivu-table-expanded-cell {
  padding: 0;
  padding-left: 50px;
}
</style>
